export default __webpack_public_path__ + "static/media/Group53.01ee0db9.svg";